import 'shared/trackjs'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import App from './components/app'

global.Giphy.renderGifMaker = (el, data) => {
    ReactDOM.render(
        <AppContainer
            warnings={false}
            errorReporter={({ error }) => {
                throw error
            }}
        >
            <App {...data} />
        </AppContainer>,
        el
    )
    if (module.hot) {
        module.hot.accept('./components/app', () => {
            const NextApp = require('./components/app').default
            ReactDOM.render(
                <AppContainer
                    warnings={false}
                    errorReporter={({ error }) => {
                        throw error
                    }}
                >
                    <NextApp {...data} />
                </AppContainer>,
                el
            )
        })
    }
}
